import { withPrefix } from 'utils/prefix'

import useAllDocumentsQuery from 'hooks/useAllDocumentsQuery'

const useDocument = path => {
	// console.log('path', path)
	const { edges } = useAllDocumentsQuery()

	// console.log('edges', edges)

	if (!path) return undefined

	const document = edges.find(edge => {
		// console.log('useDocument', {
		// 	withPrefix: withPrefix(edge.node.fields.modSlug),
		// 	path,
		// })
		return withPrefix(edge.node.fields.modSlug) === path
	})

	if (!document) {
		return undefined
	}

	return document.node
}

export default useDocument
